import { render, staticRenderFns } from "./PRILInitialProcessing.vue?vue&type=template&id=54183358&scoped=true&"
import script from "./PRILInitialProcessing.vue?vue&type=script&lang=ts&"
export * from "./PRILInitialProcessing.vue?vue&type=script&lang=ts&"
import style0 from "./PRILInitialProcessing.vue?vue&type=style&index=0&id=54183358&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54183358",
  null
  
)

export default component.exports